/*global angular*/
(function () {
    'use strict';

    angular.module('resortApp').component('hiw', {
        templateUrl: 'templates/resorts/how-it-works.html'
    });
}());
